import React from 'react'
import styled from 'styled-components/macro';
import {
  Button, Title, Text
} from 'components/atoms'
import { Modal } from 'components/molecules';
import PropTypes from 'prop-types'

export const ModalConfirm = ({
  onChange,
  isLoading,
  title,
  message,
  textDiscard,
  textConfirm,
  isOpen,
  toggle,
}) => {
  const handleChange = (hasConfirmed) => {
    onChange(hasConfirmed)
  }

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} onClickOutside={() => handleChange(false)}>
        <Title>{title}</Title>
        {message && (
          <Message>
            <Text modifiers={['content']}>
              {message}
            </Text>
          </Message>
        )}
        <Actions>
          <Button
            type="button"
            modifiers={[isLoading && 'disabled', 'marginRight', 'capitalize']}
            onClick={() => handleChange(false)}
          >
            {textDiscard}
          </Button>
          <Button
            type="submit"
            modifiers={['primary', 'capitalize']}
            onClick={() => handleChange(true)}
            loading={isLoading}
          >
            {textConfirm}
          </Button>
        </Actions>
      </Modal>
    </>
  )
}

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${props => props.theme.spacing.xl3};
`;

const Message = styled.div`
  padding-top: ${props => props.theme.spacing.xl};
`

ModalConfirm.propTypes = {
  onChange: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
  textConfirm: PropTypes.string,
  textDiscard: PropTypes.string,
}

ModalConfirm.defaultProps = {
  isOpen: false,
  isLoading: false,
  title: 'Aviso',
  message: null,
  textConfirm: 'Confirmar',
  textDiscard: 'Cancelar'
}


export default ModalConfirm
